import { parse, format, getDate } from "date-fns";

// Parses date in iso format
export const parseDate = (isoString) =>
  parse(isoString.substr(0, 10), "yyyy-MM-dd", new Date());

// Returns the min and max of the dataset for a given datakey
export const getMinMax = (data, dataKey) => {
  let min, max;
  min = max = 0;

  data.data &&
    data.data.forEach((datum) => {
      const val = datum[dataKey];
      if (val !== null) {
        if (val > max) {
          max = val;
        }
        if (val < min) {
          min = val;
        }
      }
    });

  return { min, max };
};

// Normalizes a value given a min and a max
export const normalizeValue = (value, min, max) => {
  const _value = value
    ? value > max
      ? max - 1
      : value < min
      ? min + 1
      : value
    : null;

  return _value ? (1 / (max - min)) * (_value - max) + 1 : 0;
};

export const getDaysBetween = (date1, date2) => {
  const ONE_DAY = 1000 * 60 * 60 * 24;
  const differenceMs = Math.abs(date1.getTime() - date2.getTime());
  return Math.round(differenceMs / ONE_DAY);
};

export const formatHeatmapData = (data, dataKey, unit, divisor) => {
  const output = [];

  data.data.forEach((datum) => {
    const date =
      datum.time && parse(datum.time.substr(0, 11), "yyyy-MM-dd", new Date());
    output.push({
      weekday: date && getDate(date),
      month: date && format(date, "MMM yyyy"),
      [dataKey]: datum[dataKey] / divisor || 0,
      unit: unit,
    });
  });
  return output;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/Heatmap/Heatmap.utils.js